import { render, staticRenderFns } from "./addhuodong.vue?vue&type=template&id=6848ae8a&scoped=true&"
import script from "./addhuodong.vue?vue&type=script&lang=js&"
export * from "./addhuodong.vue?vue&type=script&lang=js&"
import style0 from "./addhuodong.vue?vue&type=style&index=0&id=6848ae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848ae8a",
  null
  
)

export default component.exports